export const GOT_STREET_PARKING = 'got-street-parking';
const gotStreetParking = ({ body }) => ({
  type: GOT_STREET_PARKING,
  payload: {
    segments: body.segments,
  },
});
export default gotStreetParking;
